import { QUICKBOOKS_ENDPOINT_OLD } from '../endpoints';
import API from './../api';

export default {
    namespaced: true,

    state() {
        return {
            quickbooksData: {},
            accountMapping: [],
        };
    },

    getters: {
        quickbooksData: (state) => state.quickbooksData,
        accountMapping: (state) => state.accountMapping,
        accountChoices: (state) => state.quickbooksData.account_choices,
        classChoices: (state) => state.quickbooksData.class_choices,
    },

    mutations: {
        gotQuickbooksdata(state, response) {
            state.quickbooksData = response.data;
        },
        gotAccountMapping(state, response) {
            state.accountMapping = response.data;
        },
        gotAccountChoices(state, response) {
            state.accountChoices = response.data;
        },
        gotFirstRun(state, data) {
            state.quickbooksData.first_run = data;
        },
    },

    actions: {
        async fetchData({ commit }) {
            commit('gotQuickbooksdata', await API.get(QUICKBOOKS_ENDPOINT_OLD()));
        },
        async fetchAccountMapping({ commit }) {
            commit('gotAccountMapping', await API.get(`${QUICKBOOKS_ENDPOINT_OLD()}account-mapping/`));
        },
    },
};
